/* Rock & Roses slide cart.
   API: RRCart.open(), RRCart.close(), RRCart.refresh(), RRCart.add(items), RRCart.addForm(form)
   All cart requests carry ?recharge=true so the Recharge Cart drawer ignores them. */
(function () {
  'use strict';
  var el = document.getElementById('rr-cart');
  if (!el || window.RRCart) return;

  var cfg = el.dataset;
  var root = (cfg.rootUrl || '/').replace(/\/?$/, '/');
  var pct = parseFloat(cfg.discountPercent) || 0;
  var end = cfg.discountEnd ? Date.parse(cfg.discountEnd) : NaN;
  var panel = el.querySelector('.rr-cart__panel');
  var body = el.querySelector('[data-rr-body]');
  var foot = el.querySelector('[data-rr-foot]');
  var sums = el.querySelector('[data-rr-sums]');
  var small = el.querySelector('[data-rr-small]');
  var notice = el.querySelector('[data-rr-notice]');
  var checkout = el.querySelector('[data-rr-checkout]');
  var countEl = el.querySelector('[data-rr-count]');
  var lastFocus = null;
  var cart = null;
  var lastTier = '';

  function saleActive() { return pct > 0 && (isNaN(end) || Date.now() < end); }
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return '£' + (c / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function request(path, data) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (data) {
      opts.method = 'POST';
      if (data instanceof FormData) { opts.body = data; }
      else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(data); }
    }
    return fetch(root + path + '?recharge=true', opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (j) {
        if (!res.ok) { var err = new Error(j.description || j.message || 'Cart request failed'); err.data = j; throw err; }
        return j;
      });
    });
  }

  function isBundle(item) { var p = item.properties || {}; return !!(p._rb_id || p._rc_bundle); }
  function contents(item) {
    var c = (item.properties || {}).Contents;
    return c ? String(c).split(/\n|\|/).map(function (s) { return s.trim(); }).filter(Boolean) : [];
  }
  function visibleProps(item) {
    var p = item.properties || {};
    return Object.keys(p).filter(function (k) {
      return k.charAt(0) !== '_' && k !== 'Contents' && k !== 'ContentsCompact' && p[k] !== '' && p[k] != null;
    }).map(function (k) { return k + ': ' + p[k]; });
  }

  /* Size upgrades. The page registers them in window.RRUpgrades, keyed by variant id:
     { to, fromQty, toQty, unit, was, now, handler? }. One-time lines with quantity 1 only. */
  function upgradeFor(item) {
    var reg = window.RRUpgrades;
    if (!reg || item.quantity !== 1) return null;
    var up = reg[String(item.variant_id)];
    if (!up || !up.to) return null;
    if (!item.selling_plan_allocation) return up;
    // Subscription line: needs a matching plan on the bigger size, e.g. { plans: { '1-month plan id': '3-month plan id' }, subPrice }.
    var plan = up.plans && up.plans[String(item.selling_plan_allocation.selling_plan.id)];
    if (!plan || up.subPrice == null) return null;
    return Object.assign({}, up, { plan: plan, planName: (up.planNames || {})[plan] || '', was: up.subPrice, now: up.subPrice, sub: true });
  }
  function unitWord(unit, n) {
    if (unit === 'pouch') return n === 1 ? 'pouch' : 'pouches';
    return n === 1 ? 'bottle' : 'bottles';
  }

  /* Price each line from Shopify's figures: final_line_price already includes product-level
     discounts (e.g. an add-on offer); an applied order discount (BF15) is shared across lines.
     If the sale code isn't applied yet, estimate its saving on one-time lines. */
  function price(item, share, codeApplied) {
    var orig = item.original_line_price;
    var fin = item.final_line_price - share;
    if (!codeApplied && saleActive() && !item.selling_plan_allocation) {
      return { was: orig, now: fin - Math.round(fin * pct / 100), estimated: true };
    }
    return { was: orig, now: fin, estimated: false };
  }

  /* Add-on offer, configured in the section. Two tiers: the offer price (a Shopify automatic
     discount) when a main trigger product is in the basket, otherwise the normal price when a
     secondary trigger product is. */
  var offerTpl = el.querySelector('template[data-rr-offer]');
  var fullTpl = el.querySelector('template[data-rr-offer-full]');
  function ids(t) { return t ? (t.getAttribute('data-triggers') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean) : []; }
  var offer = offerTpl ? {
    variant: String(offerTpl.getAttribute('data-variant')),
    triggers: ids(offerTpl),
    fullTriggers: ids(fullTpl)
  } : null;
  function offerState() {
    if (!offer || !cart) return { tpl: null, orphans: [] };
    function has(list) { return cart.items.some(function (i) { return list.indexOf(String(i.product_id)) > -1; }); }
    var deal = has(offer.triggers), full = has(offer.fullTriggers);
    var inCart = cart.items.filter(function (i) { return String(i.variant_id) === offer.variant; });
    // Offer items added from the basket are removed again if no qualifying product is left.
    var orphans = deal || full ? [] : inCart.filter(function (i) { return (i.properties || {})._rr_offer; });
    var tpl = null;
    if (!inCart.length) {
      if (deal && saleActive()) tpl = offerTpl;
      else if (full) tpl = fullTpl;
    }
    return { tpl: tpl, tier: tpl === offerTpl ? 'deal' : 'full', orphans: orphans };
  }

  function render() {
    if (!cart) return;
    var count = cart.item_count;
    countEl.textContent = count ? '(' + count + ')' : '';
    document.querySelectorAll('[data-rr-cart-count], .bf-cart__count').forEach(function (b) {
      b.textContent = count; b.setAttribute('data-count', count);
    });

    if (!count) {
      body.innerHTML = '<div class="rr-cart__empty"><p>Your basket is empty.</p>' +
        '<button type="button" class="rr-cart__ghost" data-rr-close>Continue shopping</button></div>';
      foot.hidden = true;
      return;
    }

    var orderDisc = (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount != null ? d.total_allocated_amount : (d.amount || 0)); }, 0); // cart.js vs change.js shapes
    var base = cart.items_subtotal_price || 1, left = orderDisc;
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toUpperCase(); });
    var ourCode = cfg.discountCode && codes.indexOf(cfg.discountCode.toUpperCase()) > -1;
    var totWas = 0, totNow = 0, anyEstimate = false;
    var html = cart.items.map(function (item, idx) {
      var share = idx === cart.items.length - 1 ? left : Math.round(item.final_line_price * orderDisc / base);
      left -= share;
      var p = price(item, share, ourCode);
      totWas += p.was; totNow += p.now; anyEstimate = anyEstimate || (p.estimated && p.now < p.was);
      var bundle = isBundle(item);
      var sub = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
      var lines = bundle ? contents(item) : visibleProps(item);
      var image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      var up = upgradeFor(item);
      return '<div class="rr-line" data-key="' + esc(item.key) + '">' +
        '<a class="rr-line__img" href="' + esc(item.url) + '">' + (image ? '<img src="' + esc(img(image, 180)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="rr-line__info">' +
          '<a class="rr-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (sub ? '<div class="rr-line__sub">' + esc(sub) + '</div>' : '') +
          (plan ? '<div class="rr-line__sub">' + esc(plan) + '</div>' : '') +
          (lines.length ? '<ul class="rr-line__contents">' + lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' : '') +
          '<div class="rr-line__row">' +
            (bundle || (item.properties || {})._rr_offer
              ? (item.quantity > 1 ? '<span class="rr-line__qtytext">Qty ' + item.quantity + '</span>' : '<span></span>')
              : '<div class="rr-qty" role="group" aria-label="Quantity">' +
                  '<button type="button" data-rr-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-rr-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
                '</div>') +
          '</div>' +
        '</div>' +
        '<div class="rr-line__price">' +
          (p.now < p.was ? '<s>' + money(p.was) + '</s>' : '') +
          '<strong>' + money(p.now) + '</strong>' +
          '<button type="button" class="rr-line__remove" data-rr-qty="0">Remove</button>' +
        '</div>' +
        (up ? '<button type="button" class="rr-up" data-rr-up>' +
          '<span class="rr-up__text">Add <strong>' + (up.toQty - up.fromQty) + ' more ' + unitWord(up.unit, up.toQty - up.fromQty) + '</strong> for <strong>' + money(saleActive() ? up.now : up.was) + '</strong>' +
            (up.planName ? '<small class="rr-up__plan">' + esc(up.planName) + '</small>' : '') + '</span>' +
          '<span class="rr-up__cta">Add</span></button>' : '') +
      '</div>';
    }).join('');
    var os = offerState();
    if (os.tpl) html += os.tpl.innerHTML;
    lastTier = os.tier;
    body.innerHTML = html;
    if (os.orphans.length) {
      var upd = {};
      os.orphans.forEach(function (i) { upd[i.key] = 0; });
      request('cart/update.js', { updates: upd }).then(function (c) { cart = c; render(); }, function () {});
    }

    var lineDisc = cart.items.reduce(function (a, i) { return a + (i.original_line_price - i.final_line_price); }, 0);
    var vipDisc = totWas - lineDisc - totNow;
    var rows = '<div><dt>Subtotal</dt><dd>' + money(totWas) + '</dd></div>';
    if (lineDisc > 0) rows += '<div class="rr-sum--save"><dt>Offer saving</dt><dd>−' + money(lineDisc) + '</dd></div>';
    if (vipDisc > 0) {
      var named = anyEstimate || ourCode;
      var label = named ? (cfg.discountLabel || (pct + '% off')) : 'Discount' + (codes.length ? ' (' + codes.join(', ') + ')' : '');
      rows += '<div class="rr-sum--save"><dt>' + esc(label) + (named && cfg.discountCode ? ' <span>(' + esc(cfg.discountCode) + ')</span>' : '') + '</dt><dd>−' + money(vipDisc) + '</dd></div>';
    }
    if (cfg.deliveryText) rows += '<div><dt>Delivery</dt><dd>Free</dd></div>';
    rows += '<div class="rr-sum--total"><dt>Total</dt><dd>' + money(totNow) + '</dd></div>';
    sums.innerHTML = rows;

    small.textContent = anyEstimate
      ? 'Your ' + (cfg.discountCode || 'discount') + ' saving is added automatically at checkout.'
      : ourCode ? 'Your ' + cfg.discountCode + ' saving is applied.' : (cfg.deliveryText || '');
    var href = root + 'checkout';
    if (saleActive() && cfg.discountCode) href = root + 'discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent('/checkout');
    checkout.setAttribute('href', href);
    foot.hidden = false;
    trackViews();
  }

  function showNotice(text) {
    notice.textContent = text || '';
    notice.hidden = !text;
  }
  function busy(on) { panel.classList.toggle('is-busy', !!on); }

  function refresh() {
    return request('cart.js').then(function (c) { cart = c; render(); reconcileUpgrades(c); return c; });
  }

  /* Measurement. GA4 events go straight to the page's GA4 tags through gtag (consent mode
     applies): bf_upgrade_view / bf_upgrade and bf_offer_view / bf_offer_add. Upgrades and
     add-ons are also written to the order as cart attributes, so they can be checked against
     real purchases in Shopify. */
  var seen = {};
  var tp = (cfg.trackPrefix || 'BF').trim() || 'BF';
  var ev = tp.toLowerCase();
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'; }
  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      var ga = Object.keys(window.google_tag_manager || {}).filter(function (k) { return /^G-/.test(k); });
      if (ga.length) window.gtag('event', name, Object.assign({ send_to: ga }, params));
    } catch (e) {}
  }
  function trackViews() {
    if (!cart || el.hidden) return;
    cart.items.forEach(function (i) {
      var up = upgradeFor(i);
      if (!up || seen['u' + i.variant_id]) return;
      seen['u' + i.variant_id] = 1;
      track(ev + '_upgrade_view', { item_name: i.product_title, from_qty: up.fromQty, to_qty: up.toQty,
        value: (saleActive() ? up.now : up.was) / 100, currency: cur() });
    });
    if (body.querySelector('.rr-offer') && !seen['o' + lastTier]) {
      seen['o' + lastTier] = 1;
      track(ev + '_offer_view', { offer_tier: lastTier });
    }
  }
  /* Keep the upgrade note honest: if an upgraded line is no longer in the cart (switched back
     or removed), move that entry from "<prefix> cart upgrades" to "<prefix> upgrades reverted". */
  function reconcileUpgrades(c) {
    try {
      var a = (c && c.attributes) || {};
      var ka = tp + ' cart upgrades', kr = tp + ' upgrades reverted', kb = tp + ' basket before upgrade';
      if (!a[ka]) return;
      var live = {};
      (c.items || []).forEach(function (i) { var u = (i.properties || {})._rr_upgrade; if (u) live[i.product_title + ': ' + u] = 1; });
      var keep = [], gone = [];
      String(a[ka]).split(' | ').forEach(function (entry) {
        var m = entry.match(/^(.*?: \d+ to \d+)/);
        if (m && live[m[1]]) keep.push(entry); else gone.push(entry);
      });
      if (!gone.length) return;
      var attrs = {};
      attrs[ka] = keep.join(' | ');
      attrs[kr] = (a[kr] ? a[kr] + ' | ' : '') + gone.join(' | ');
      if (!keep.length) attrs[kb] = '';
      saveAttrs(attrs);
    } catch (e) {}
  }
  function saveAttrs(attrs) {
    return request('cart/update.js', { attributes: attrs }).then(function (c) { cart = c; }, function () {});
  }

  function open() {
    if (!el.hidden && el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    trackViews();
    document.documentElement.classList.add('rr-cart-lock');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var close = el.querySelector('.rr-cart__close');
      if (close) close.focus();
    });
  }
  function close() {
    el.classList.remove('is-open');
    document.documentElement.classList.remove('rr-cart-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function addRequest(data) {
    showNotice('');
    busy(true);
    return request('cart/add.js', data)
      .then(refresh)
      .then(function (c) { open(); return c; }, function (err) {
        showNotice(err.message || 'Sorry, we couldn’t add that. Please try again.');
        return refresh().then(open, open).then(function () { throw err; });
      })
      .finally(function () { busy(false); });
  }
  function add(items) { return addRequest({ items: items }); }
  function addForm(form) { return addRequest(new FormData(form)); }
  function change(key, qty) {
    showNotice('');
    busy(true);
    return request('cart/change.js', { id: key, quantity: qty })
      .then(function (c) { cart = c; render(); reconcileUpgrades(c); })
      .catch(function (err) { showNotice(err.message || 'Sorry, that didn’t update. Please try again.'); return refresh(); })
      .finally(function () { busy(false); });
  }

  function upgrade(key) {
    var item = (cart && cart.items || []).filter(function (i) { return i.key === key; })[0];
    var up = item && upgradeFor(item);
    if (!up) return Promise.resolve();
    showNotice('');
    busy(true);
    var before = cart.total_price;
    var adding = up.handler ? up.handler(item, up) : request('cart/add.js', { items: [Object.assign({ id: Number(up.to), quantity: 1 }, up.plan ? { selling_plan: Number(up.plan) } : {}, { properties: Object.assign({ _rr_upgrade: up.fromQty + ' to ' + up.toQty }, (item.properties || {})._added_from ? { _added_from: item.properties._added_from } : {}) })] });
    return Promise.resolve(adding)
      .then(function () { return request('cart/change.js', { id: key, quantity: 0 }); })
      .then(function (c) {
        cart = c; render();
        var gain = c.total_price - before;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'cart_upgrade', upgrade_from: String(item.variant_id), upgrade_to: String(up.to),
            upgrade_value: (saleActive() ? up.now : up.was) / 100, currency: cur() });
        } catch (e) {}
        track(ev + '_upgrade', { item_name: item.product_title, from_qty: up.fromQty, to_qty: up.toQty,
          value: gain / 100, basket_before: before / 100, basket_after: c.total_price / 100, currency: cur() });
        var a = c.attributes || {};
        var label = item.product_title + ': ' + up.fromQty + ' to ' + up.toQty + ' ' + unitWord(up.unit, up.toQty) + ' (+' + money(gain) + ')';
        var ka = tp + ' cart upgrades', kb = tp + ' basket before upgrade';
        var attrs = {};
        attrs[ka] = (a[ka] ? a[ka] + ' | ' : '') + label + (up.sub ? ' (subscription)' : '');
        if (!a[kb]) attrs[kb] = money(before);
        return saveAttrs(attrs);
      })
      .catch(function () { showNotice('Sorry, we couldn’t upgrade that. Please try again.'); return refresh(); })
      .finally(function () { busy(false); });
  }

  function addOffer() {
    if (!offer) return Promise.resolve();
    showNotice('');
    busy(true);
    var tier = lastTier, before = cart.total_price;
    return request('cart/add.js', { items: [{ id: Number(offer.variant), quantity: 1, properties: { _rr_offer: tier } }] })
      .then(refresh)
      .then(function (c) {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cart_offer_add', offer_variant: offer.variant, offer_tier: tier }); } catch (e) {}
        track(ev + '_offer_add', { offer_tier: tier, value: (c.total_price - before) / 100, currency: cur() });
        return saveAttrs({ 'BF mixer add-on': tier === 'deal' ? '£9.99 with 12-week bundle' : 'Normal price' });
      }, function () { showNotice('Sorry, we couldn’t add that. Please try again.'); })
      .finally(function () { busy(false); });
  }

  el.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rr-close], [data-rr-qty], [data-rr-up], [data-rr-offer-add]');
    if (!t) return;
    if (t.hasAttribute('data-rr-close')) { close(); return; }
    if (t.hasAttribute('data-rr-offer-add')) { addOffer(); return; }
    if (t.hasAttribute('data-rr-up')) { var ln = t.closest('[data-key]'); if (ln) upgrade(ln.getAttribute('data-key')); return; }
    var line = t.closest('[data-key]');
    if (line) change(line.getAttribute('data-key'), Math.max(0, parseInt(t.getAttribute('data-rr-qty'), 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (el.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Capture phase, so other cart scripts (e.g. Recharge) can't take the click first.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-rr-cart-open], .bf-cart');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    refresh();
  }, true);
  window.addEventListener('pageshow', function () { refresh(); });

  function addRaw(items) { return request('cart/add.js', { items: items }); }

  window.RRCart = { open: open, close: close, refresh: refresh, add: add, addForm: addForm, addRaw: addRaw, change: change, upgrade: upgrade };
  refresh();
})();
